import { HTTP_METHODS } from '@studio/constants/axios';
import { subtitlesUrl } from '@studio/constants/env-variables';

export const root = {};

export const id = {
  [HTTP_METHODS.GET]: {
    url: `${subtitlesUrl}/download/@id/@filename`,
    method: HTTP_METHODS.GET,
    params: {} as { filename: string; id: string },
    query: {} as {
      end?: string;
      start?: string;
    },
    response: '' as string,
  },
};
